import { Constants } from '../_constants/shared.constants';
export const  successManageProfile=(data)=> {
     return{ type: Constants.manageProfile.MANAGE_PROFILE,data }
     }
  